import { UserModule } from '@/store/modules/user';
import Cookies from 'js-cookie';

// App
const sidebarStatusKey = 'sidebar_status';
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey);
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus);

// User
const UserToken = 'bxgj_web_id';
const LocUserToken = 'loc_bxgj_web_id';
////腾讯tim停用 20251231
// const TIMLogin = 'bxgj_web_TIMLogin';
const NIMLogin = 'bxgj_web_NIMLogin';
const Domain = '.baoxiuguanjia.com';
const ExpireTime = '.baoxiuguanjia.com.ExpireTime.';
// 菜单节点id
const MenuNodeId = 'menuNodeId.baoxiuguanjia.com';

export function setUserToken(token: string) {
  Cookies.set(UserToken, token, { domain: Domain });
}
export function setLocUserToken(token: string) {
  Cookies.set(LocUserToken, token);
}
export function setNodeIdList(nodeIds: number[]) {
  Cookies.set(MenuNodeId, nodeIds);
}
export function setExpireTime(time: string) {
  Cookies.set(ExpireTime + UserModule.getCompanyId, time, { domain: Domain });
}
export function getUserToken() {
  return Cookies.get(UserToken);
}
export function getLocUserToken() {
  return Cookies.get(LocUserToken);
}
export function getNodeIdList() {
  return Cookies.get(MenuNodeId);
}
export function getExpireTime() {
  return Cookies.get(ExpireTime + UserModule.getCompanyId);
}
export function removeUserToken() {
  return Cookies.remove(UserToken);
}
export function removeLocUserToken() {
  return Cookies.remove(LocUserToken);
}
export function removeNodeIdList() {
  return Cookies.remove(MenuNodeId);
}

//腾讯tim停用 20251231
// export function setTIMLogin(login: string) {
//   Cookies.set(TIMLogin, login);
// }
// export function getTIMLogin() {
//   return Cookies.get(TIMLogin);
// }
// export function removeTIMLogin() {
//   return Cookies.remove(TIMLogin);
// }

export function setNIMLogin(login: string) {
  Cookies.set(NIMLogin, login);
}
export function getNIMLogin() {
  return Cookies.get(NIMLogin);
}
export function removeNIMLogin() {
  return Cookies.remove(NIMLogin);
}
